
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            filteredLearningPaths: [],
            learningPathSorting: null
        }
    },
    computed: {
        ...mapGetters({
            uncompletedLearningPaths: 'LearningPaths/getUncompletedLearningPaths',
        })
    },
    methods: {
        onLearningPathListChange (newLearningPathsList) {
            this.filteredLearningPaths = newLearningPathsList
        },
        learningPathSortingChange (sortBy) {
            this.learningPathSorting = sortBy
        }
    },
    async created () {
        await this.$store.dispatch('LearningPaths/loadSubscribedLearningPaths')
    }
}
